import { makeRequest } from "../lib/request";
import { useUserStore } from "../store/userStore";

export function useEvent() {
  const accessToken = useUserStore((state) => state.accessToken);
  const impersonationToken = useUserStore((state) => state.impersonationToken);

  const event = async (payload: any) => {
    if (accessToken) {
      await makeRequest(`private/event`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          Authorization: `Bearer ${impersonationToken || accessToken}`,
          "Content-Type": "application/json",
        },
      });
    }
  };

  const markNotificationsRead = async (type: any) => {
    if (accessToken) {
      await makeRequest(`private/notifications`, {
        method: "PATCH",
        body: JSON.stringify({ type }),
        headers: {
          Authorization: `Bearer ${impersonationToken || accessToken}`,
          "Content-Type": "application/json",
        },
      });
    }
  };

  return {
    event,
    markNotificationsRead,
  };
}
